import axios from "axios";
import useAuthStore from "../store/useAuthStore";


const api = axios.create();

// Add request interceptor → attach token + dynamic baseURL
api.interceptors.request.use(
  (config) => {
    const { token, isInternal } = useAuthStore.getState();
    // Dynamically compute base URL
    const BASE_URL = isInternal
      ? process.env.REACT_APP_BACKEND_URL
      : process.env.REACT_APP_CLIENT_URL;

    console.log(BASE_URL,isInternal)

    config.baseURL = `${BASE_URL}/api`;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor → handle 403
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      const { setToken } = useAuthStore.getState();
      setToken(null);
      window.cookieStore.delete("authToken");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;
